import { Heading } from "../heading/Heading";
import { Text } from "../text/Text";
import { Box } from "../box/Box";

import "./QuizQuestion.css";

import type { ReactNode } from "react";

export interface QuizQuestionProps {
  children?: ReactNode;
  description?: string;
  title?: ReactNode;
}

export function QuizQuestion({
  children,
  description,
  title,
}: QuizQuestionProps) {
  return (
    <div className="QuizQuestion">
      {title && (
        <Heading level="3" displayLevel="6">
          {title}
        </Heading>
      )}

      {description && (
        <Text as="p">
          <span
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </Text>
      )}

      <Box gap={16} direction="column">
        {children}
      </Box>
    </div>
  );
}
